import { createSlice } from "@reduxjs/toolkit";

export const name = "networkDefender";

export const networkDefenderSlice = createSlice({
  name,
  initialState: {
    distinctHosts: [],
    distinctHostsLoading: false,
    networkDetections: [],
    networkDetectionsSubmissions: [],
    networkDetectionsLoading: false,
  },
  reducers: {
    RequestDistinctHosts: (state) => {
      state.distinctHostsLoading = true;
    },
    SuccessDistinctHosts: (state, action) => {
      state.distinctHosts = action.payload;
      state.distinctHostsLoading = false;
    },
    FailureDistinctHosts: (state) => {
      state.distinctHosts = [];
      state.distinctHostsLoading = false;
    },
    RequestNetworkDetections: (state) => {
      state.networkDetectionsLoading = true;
    },
    SuccessNetworkDetections: (state, action) => {
      const { network_detections, sbox_submissions } = action.payload;
      state.networkDetections = network_detections;
      state.networkDetectionsSubmissions = sbox_submissions;
      state.networkDetectionsLoading = false;
    },
    FailureNetworkDetections: (state) => {
      state.networkDetections = [];
      state.networkDetectionsLoading = false;
    },
  },
});

export default networkDefenderSlice;
